import Vue from 'vue'
import parseErrors from './parseErrors'

export default e => {
  Vue.toaster.error(e.message)
}
